import React from 'react';
import { Controller } from 'react-hook-form';

import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';

const useStyles = jss.makeStyles((_theme) => ({
  formControl: {
    margin: 0,
  },
  errorText: {},
}));

const ControlledSelect = ({
  name,
  label,
  control,
  rules,
  defaultValue,
  children,
  errorMessage,
  controllerProps,
  selectProps,
  ...props
}) => {
  const labelId = `controlled-label-${name}`;
  const styles = useStyles();

  return (
    <mui.FormControl {...props} className={jss.combineStyles(props.className, styles.formControl)}>
      <mui.InputLabel id={labelId}>{label}</mui.InputLabel>

      <Controller
        {...controllerProps}
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        as={
          <mui.Select labelId={labelId} label={label} {...selectProps}>
            {children}
          </mui.Select>
        }
      />

      {!!errorMessage && <mui.FormHelperText className={styles.errorText}>{errorMessage}</mui.FormHelperText>}
    </mui.FormControl>
  );
};

export default ControlledSelect;
